import { theme } from 'antd';

const { useToken } = theme;

export const useAppointments = () => {
  const { token } = useToken();
  
  return [
    { 
      id: 'A001', 
      patient: 'Sarah Johnson', 
      time: 'Today, 2:30 PM', 
      type: 'Follow-up', 
      duration: '30 min',
      urgent: true,
      avatarColor: token.blue6
    },
    { 
      id: 'A002', 
      patient: 'Michael Chen', 
      time: 'Tomorrow, 10:00 AM', 
      type: 'Consultation', 
      duration: '45 min',
      urgent: false,
      avatarColor: token.green6
    },
    { 
      id: 'A003', 
      patient: 'Robert Lewis', 
      time: 'Today, 4:15 PM', 
      type: 'Lab Results', 
      duration: '20 min',
      urgent: true,
      avatarColor: token.orange6
    },
    { 
      id: 'A004', 
      patient: 'Emma Wilson', 
      time: 'Apr 10, 11:15 AM', 
      type: 'Prenatal Checkup', 
      duration: '60 min',
      urgent: false,
      avatarColor: token.purple6
    }
  ];
};